export const restUrls = {
  loadResellerWhitelabel: '/reseller/white_label',
  authUrl: '/login/authenticate',
  verifyTwoFaChallengeUrl: '/login/verify_challenge',
  passwordRecovery: '/login/password_recovery',
  userInfo: '/me/whoami',
  googleOidcLoginUrl: '/google_oidc/',
  internalUserLoginUrl: '/usg/',
};

export const defaultSupportEmail = 'support@upsellguru.com';

export const googleOidcErrorKey = 'google_oidc_failed';
export const googleOidcErrorMessage = 'Google sign-in failed. Please try again.';
